import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SettingConstants } from 'src/core/constants/setting-constant';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';

@Component({
    selector: 'ca-voice-morphing-settings',
    templateUrl: './voice-morphing-settings.component.html',
    styleUrl: './voice-morphing-settings.component.scss',
    standalone: false
})
export class VoiceMorphingSettingsComponent implements OnInit {
  form: FormGroup;

  constructor(
    private config: ConfigStateService,
    private fb: FormBuilder,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private localizationService: LocalizationService
  ) {
    this.form = fb.group({
      enabled: [JSON.parse(this.config.getSetting(SettingConstants.MorphingEnabled).toLowerCase())],
    });
    this.form
      .get('enabled')
      .patchValue(
        JSON.parse(this.config.getSetting(SettingConstants.MorphingEnabled).toLowerCase())
      );
  }

  ngOnInit(): void {}

  onSubmitForm() {
    if (!this.form.valid) {
      return;
    }

    const settings: ConfigurationSettingsDto[] = [];

    settings.push({
      settingName: SettingConstants.MorphingEnabled,
      settingValue: this.form.get('enabled').value.toString(),
    });

    this.settingService.saveSetting(settings).subscribe(() => {
      this.toastr.success(
        this.localizationService.instant('AbpSettingManagement::SavedSuccessfully')
      );
    });
  }
}
